"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconHotelThematic = void 0;
var React = __importStar(require("react"));
var IconHotelThematic = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#464650", fillRule: "evenodd", d: "M3,18 L21,18 L21,16 L3,16 L3,18 Z M6.151,4.148 C6.246,4.053 6.372,4 6.505,4 L17.481,4 C17.751,4 17.98,4.228 17.981,4.497 L17.998,8 L17,8 L17,6.5 C17,6.224 16.776,6 16.5,6 L13.5,6 C13.224,6 13,6.224 13,6.5 L13,8 L11,8 L11,6.5 C11,6.224 10.776,6 10.5,6 L7.5,6 C7.224,6 7,6.224 7,6.5 L7,8 L6.021,8 L6.005,4.502 C6.004,4.369 6.056,4.243 6.151,4.148 L6.151,4.148 Z M14,9 L16,9 L16,7 L14,7 L14,9 Z M8,9 L10,9 L10,7 L8,7 L8,9 Z M5.83,9 L7,9 L7,9.5 C7,9.776 7.224,10 7.5,10 L10.5,10 C10.776,10 11,9.776 11,9.5 L11,9 L13,9 L13,9.5 C13,9.776 13.224,10 13.5,10 L16.5,10 C16.776,10 17,9.776 17,9.5 L17,9 L18.17,9 L20.742,15 L3.258,15 L5.83,9 Z M21.981,15.408 C21.975,15.373 21.974,15.336 21.959,15.304 L21.959,15.303 L19,8.396 L18.981,4.493 C18.978,3.67 18.305,3 17.481,3 L6.505,3 C6.104,3 5.726,3.157 5.442,3.442 C5.158,3.729 5.003,4.106 5.005,4.507 L5.022,8.345 L2.041,15.303 L2.041,15.304 C2.026,15.336 2.025,15.373 2.019,15.408 C2.013,15.438 2,15.469 2,15.499 L2,15.5 L2,18.5 C2,18.776 2.224,19 2.5,19 L3.993,19 C3.993,19.001 3.993,19.001 3.993,19.002 L4,20.502 C4.001,20.777 4.225,21 4.5,21 C4.751,21.001 5.001,20.774 5,20.498 L4.993,19 L18.993,19 C18.993,19.001 18.993,19.001 18.993,19.002 L19,20.502 C19.001,20.777 19.225,21 19.5,21 C19.728,21.001 20.001,20.774 20,20.498 L19.993,19 L21.5,19 C21.776,19 22,18.776 22,18.5 L22,15.5 L22,15.499 C22,15.469 21.987,15.438 21.981,15.408 L21.981,15.408 Z" }))); };
exports.IconHotelThematic = IconHotelThematic;
exports.IconHotelThematic.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconHotelThematic;
